module.exports = __webpack_public_path__ + "img/coding.11c8e4ea.png";